var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconInstallerAddress(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 32,
    viewBox: "0 0 33 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.47731 14.4735C8.88268 13.4071 8.54114 12.2183 8.47906 10.9988C8.41697 9.77939 8.63602 8.562 9.11927 7.44068C9.60251 6.31937 10.337 5.32414 11.2661 4.53185C12.1952 3.73957 13.2939 3.17143 14.4775 2.87133C15.661 2.57123 16.8977 2.54719 18.0921 2.80107C19.2864 3.05495 20.4064 3.57996 21.3655 4.33554C22.3247 5.09112 23.0973 6.05706 23.6238 7.15874C24.1502 8.26043 24.4164 9.46839 24.4018 10.6893C24.4062 11.9909 24.0868 13.2731 23.4723 14.4204",
    stroke: "#3C3C3C",
    strokeWidth: 0.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.47656 14.474L9.88818 15.3769L16.4874 29.279L23.5247 14.4209",
    stroke: "#3C3C3C",
    strokeWidth: 0.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.4857 14.66C18.6784 14.66 20.4559 12.8825 20.4559 10.6899C20.4559 8.49721 18.6784 6.71973 16.4857 6.71973C14.2931 6.71973 12.5156 8.49721 12.5156 10.6899C12.5156 12.8825 14.2931 14.66 16.4857 14.66Z",
    stroke: "#3C3C3C",
    strokeWidth: 0.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconInstallerAddress);
export default __webpack_public_path__ + "static/media/icon_installer_address.2286627f56ce6dc53debae1004f45bb6.svg";
export { ForwardRef as ReactComponent };